<template>
    <div>
        <InputsContactInfo
            class="client-item-modal-contact-data"
            :isModal="true"
            :saving="saving"
        />

        <hr class="mb-3" />

        <InputsInvoicesEmails :saving="saving" />

        <hr class="mt-3 mb-3" />

        <InputsMaintenanceEmails :saving="saving" />
    </div>
</template>

<script>
import InputsContactInfo from './InputsContactInfo.vue'
import InputsInvoicesEmails from './InputsInvoicesEmails.vue'
import InputsMaintenanceEmails from './InputsMaintenanceEmails.vue'

export default {
    name: 'ClientItemModalContactData',

    components: {
        InputsContactInfo,
        InputsInvoicesEmails,
        InputsMaintenanceEmails,
    },

    props: {
        saving: {
            type: Boolean,
            required: true,
        },
    },
}
</script>